import { combineReducers } from 'redux'
import reports, { STATE_KEY as REPORTS_STATE_KEY } from './reports'

export const STATE_KEY = 'reports'

const reducer = combineReducers({
	[REPORTS_STATE_KEY]: reports
})

export default reducer